import { render, staticRenderFns } from "./ComponentServiceZoneVehicles.vue?vue&type=template&id=2ec73ffa&"
import script from "./ComponentServiceZoneVehicles.vue?vue&type=script&lang=ts&"
export * from "./ComponentServiceZoneVehicles.vue?vue&type=script&lang=ts&"
import style0 from "./ComponentServiceZoneVehicles.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports